import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../helpers/common'
import { formatCompanyInfoData } from '../../../helpers/companyInfo'
import { register } from '../../../helpers/reducerRegistry'
import { PERFORMANCE_SCORE_COLOR, SCORE_TYPE } from '../constant'
import {
  getAlertDetails,
  getAlertList,
  getCompanyInfo,
  getScoreRangesCreditRisk,
  getScoreRangesPerformance,
} from './thunk'

const initialState = {
  scoreRanges: {
    [SCORE_TYPE.CREDIT_RISK]: [],
    [SCORE_TYPE.PERFORMANCE]: [],
  },

  companyInfo: {},

  alertDetail: {},
  isRedirect404: false,

  alertIds: [],
  alertById: {},

  loading: {
    scoreRanges: false,
    companyInfo: false,
    alertDetail: true,
    alertList: true,
  },
}

const slice = createSlice({
  name: 'alerts/detail',
  initialState,
  reducers: {
    resetStore: () => initialState,
    changeAlertList: (state, { payload }) => {
      state.alertIds = payload.map((item) => item.recordId)
      state.alertById = keyBy(payload, 'recordId')
    },
  },
  extraReducers: (builder) => {
    //getScoreRangesCreditRisk
    builder.addCase(getScoreRangesCreditRisk.pending, (state) => {
      state.loading.scoreRanges = true
    })
    builder.addCase(getScoreRangesCreditRisk.fulfilled, (state, action) => {
      state.loading.scoreRanges = false
      state.scoreRanges[SCORE_TYPE.CREDIT_RISK] = [...action.payload]
        .reverse()
        .map((item, index) => ({
          ...item,
          color: item.scoreRangeCode,
        }))
    })
    //getScoreRangesPerformance
    builder.addCase(getScoreRangesPerformance.pending, (state) => {
      state.loading.scoreRanges = true
    })
    builder.addCase(getScoreRangesPerformance.fulfilled, (state, action) => {
      state.loading.scoreRanges = false
      state.scoreRanges[SCORE_TYPE.PERFORMANCE] = [...action.payload]
        .reverse()
        .map((item, index) => ({
          ...item,
          color: PERFORMANCE_SCORE_COLOR[index],
        }))
    })
    //getCompanyInfo
    builder.addCase(getCompanyInfo.pending, (state) => {
      state.loading.companyInfo = true
    })
    builder.addCase(getCompanyInfo.fulfilled, (state, action) => {
      state.companyInfo = formatCompanyInfoData(action.payload)
      state.loading.companyInfo = false
    })
    builder.addCase(getCompanyInfo.rejected, (state) => {
      state.loading.companyInfo = false
    })
    // getAlertDetails
    builder.addCase(getAlertDetails.pending, (state) => {
      state.loading.alertDetail = true
    })
    builder.addCase(getAlertDetails.fulfilled, (state, action) => {
      state.alertDetail = action.payload
      state.loading.alertDetail = false
      state.isRedirect404 = false
    })
    builder.addCase(getAlertDetails.rejected, (state, action) => {
      state.loading.alertDetail = action.payload.loading
      state.isRedirect404 = true
    })
    // getAlertList
    builder.addCase(getAlertList.pending, (state) => {
      state.loading.alertList = true
    })
    builder.addCase(getAlertList.fulfilled, (state, { payload }) => {
      state.alertIds = payload.data.map((item) => item.recordId)
      state.alertById = keyBy(payload.data, 'recordId')
      state.loading.alertList = false
    })
    builder.addCase(getAlertList.rejected, (state, action) => {
      state.loading.alertList = action.payload.loading
    })
  },
})

export const selectScoreRanges = (scoreType, callback) => (state) => {
  const data = state[slice.name].scoreRanges[scoreType]
  return callback ? callback(data) : data
}

export const selectCompanyInfo = (state) => state[slice.name].companyInfo

export const selectAlertDetail = (state) => state[slice.name].alertDetail
export const selectIsRedirect404 = (state) => state[slice.name].isRedirect404

export const selectAlertIds = (state) => state[slice.name].alertIds
export const selectAlertById = (id, attr) => (state) => {
  const data = state[slice.name].alertById
  if (!id) return data
  if (!attr) return data[id]
  return data[id]?.[attr]
}

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  if (Array.isArray(type)) return type.some((i) => loadingObj[i])
  return loadingObj[type]
}

export const { resetStore, changeAlertList } = slice.actions

register(slice.name, slice.reducer)
